module.exports = __webpack_public_path__ + "img/logo-white.374181ab.svg";